import React from "react";
import PropTypes from 'prop-types';
import styles from './data-container.module.scss'
const DataContainer = ({ text, value, icon , background }) => {
    return (
        <div className={styles.outerBox} style={{background:background}}>
            <div>
                <h4>{text}</h4>
                <h2><b>{value}</b></h2>
            </div>
            {icon}
        </div>
    )
}


DataContainer.propTypes = {
    text: PropTypes.string,
    value: PropTypes.number,
    background :PropTypes.string,
    icon: PropTypes.element


}

export default DataContainer